/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import colors from "assets/css/colors";
import fontFamily from "assets/css/fontFamily";

const getBaseInputCss = ({ defaultPlaceholderStyle }) => {
  const textTransform = defaultPlaceholderStyle ? "lowercase" : "capitalize";

  return css`
    padding: 10px 32px 10px 12px;
    box-sizing: border-box;
    border: 1px solid ${colors.strokeGrey};
    border-radius: 4px;
    background-color: ${colors.white};
    font-family: ${fontFamily.roboto};

    &:focus {
      outline: none;
      border: 1px solid ${colors.mainBlue};
    }

    &:disabled {
      background-color: ${colors.bgGrey};
      border: 1px solid ${colors.strokeGrey};
      color: variables.$grey;
    }

    &::placeholder {
      color: ${colors.grey};
      text-transform: ${textTransform};
    }
  `;
};

const getInputErrorCss = ({ defaultPlaceholderStyle }) => [
  getBaseInputCss({ defaultPlaceholderStyle }),
  css`
    border: 1px solid ${colors.red};
    color: ${colors.textBlack};

    &:focus {
      border: 1px solid ${colors.red};
    }
  `,
];

export function inputCss({ error, defaultPlaceholderStyle }) {
  const defaultInputCss = getBaseInputCss({ defaultPlaceholderStyle });

  return error ? getInputErrorCss({ defaultPlaceholderStyle }) : defaultInputCss;
}
